import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const r = await axios.post(`${API}/newsletter`, { email });
      if (r.data.already_subscribed) {
        toast("Ești deja abonat.");
      } else {
        toast("Mulțumim. Te-am adăugat pe lista lunii.");
      }
      setEmail("");
    } catch (err) {
      toast.error("Eroare. Reîncearcă.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      className="relative py-32 md:py-44 bg-[#F4ECDD] overflow-hidden"
      data-testid="newsletter-section"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#B8954C] mb-6">Newsletter</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-[#1A1612] leading-[1.1] mb-6" data-testid="newsletter-title">
            Primește invitații exclusive.
          </h2>
          <div className="sep-line max-w-xs mx-auto mb-8">
            <span className="diamond" />
          </div>
          <p className="text-base md:text-lg text-[#6E665A] font-light max-w-xl mx-auto leading-relaxed mb-12">
            Lasă-ți emailul pentru lansări limitate, evenimente private și ritualuri sub lună.
          </p>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder="Adresa ta de email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-light flex-1 text-center sm:text-left"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              className="btn-pill"
              disabled={loading}
              data-testid="newsletter-submit"
            >
              {loading ? "..." : "Abonează-te"}
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Newsletter;
